import { useState } from 'react'
import { useAlert } from 'react-alert'

import { deleteCustomer } from '../../../main/usecases'

import { useOnChangeDetect, useModalBox } from '../../contexts'
import { Button } from '../../components'

const DeleteCustomerModal = ({ id }: any) => {
  const [loading, setLoading] = useState(false)
  const { modalClose } = useModalBox()
  const alert = useAlert()
  const { setRefresh } = useOnChangeDetect()

  const handleDeleteCustomer = async (id: number) => {
    try {
      setLoading(true)
      await deleteCustomer({
        id: id
      }).delete()
      modalClose(true)
      alert.show('Paciente deletado com sucesso', {
        type: 'success',
        timeout: 4000
      })
      setRefresh((prev: any) => !prev)
    } catch (error) {
      console.error(error)
      alert.show('Erro ao deletar um paciente', {
        type: 'error',
        timeout: 4000
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="delete-modal">
      <p>
        Deseja realmente deletar o paciente? Essa ação não poderá ser revertida.
      </p>
      <div>
        <Button
          disabled={loading}
          hasredButton
          onClick={() => handleDeleteCustomer(id)}
        >
          Sim
        </Button>
        <Button hasSecodaryButton onClick={modalClose}>
          Não
        </Button>
      </div>
    </div>
  )
}

export default DeleteCustomerModal
